import type { ReactNode } from 'react';

import { BRAND } from '@/theme';

export const SVG_INK = BRAND.ink;
export const SVG_SUBTLE = '#5b5b63';

type SvgLabelProps = {
  x: number;
  y: number;
  width: number;
  height: number;
  children: ReactNode;
  size?: number;
  weight?: number;
  color?: string;
  align?: 'center' | 'left';
};

/**
 * Text for the landing's drawn diagrams. A foreignObject lets labels wrap inside their box,
 * so longer Vietnamese labels stay readable instead of overflowing the shape.
 */
export function SvgLabel({
  x,
  y,
  width,
  height,
  children,
  size = 12,
  weight = 600,
  color = SVG_INK,
  align = 'center'
}: SvgLabelProps) {
  return (
    <foreignObject x={x} y={y} width={width} height={height}>
      <div
        style={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: align === 'center' ? 'center' : 'flex-start',
          textAlign: align,
          padding: '0 6px',
          fontSize: size,
          fontWeight: weight,
          lineHeight: 1.2,
          color,
          overflowWrap: 'anywhere'
        }}
      >
        {children}
      </div>
    </foreignObject>
  );
}

/** Arrowhead marker; ids are per diagram since several share the page. */
export function ArrowMarker({ id, color = SVG_INK }: { id: string; color?: string }) {
  return (
    <marker
      id={id}
      viewBox="0 0 10 10"
      refX="9"
      refY="5"
      markerWidth="6"
      markerHeight="6"
      orient="auto-start-reverse"
    >
      <path d="M0 0 L10 5 L0 10 z" fill={color} />
    </marker>
  );
}
